import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import Clients from "@/components/site/Clients";
import ProductDemo from "@/components/site/ProductDemo";
import Authors from "@/components/site/Authors";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import SEO from "@/components/site/SEO";

export default function Landing() {
  return (
    <main data-testid="landing-root" className="relative min-h-screen bg-white">
      <SEO
        title="licito.guru — IA para licitações e contratos públicos | Lei 14.133"
        description="Inteligência artificial especializada em licitações e contratos públicos. Gera ETP, DFD, TR, edital e contrato conforme a Lei 14.133. Analisa documentos, apura preços via PNCP e encontra atas. Treinada pelos Profs. Joel Niebuhr e Gustavo Schiefler."
        path="/"
      />
      <Nav />
      <Hero />
      <Features />
      <Clients />
      <ProductDemo />
      <Authors />
      <FinalCTA />
      <Footer />
    </main>
  );
}
